import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { Typography } from "@/modules/theme/components/Typography/Typography";
import { useTheme } from "@/modules/theme/hooks/useTheme";
import { grey } from "@/modules/theme/utils/colors";
import { Theme } from "@/modules/theme/utils/createTheme";

const translationNamespace = "layouts/Common/Base404NotFoundLayout";

interface Base404NotFoundLayoutProps {
  children: React.ReactNode;
  className?: string;
}

export function Base404NotFoundLayout({
  children,
  className,
}: Base404NotFoundLayoutProps) {
  const { t } = useTranslation(translationNamespace);
  const classes = createStyles(useTheme());

  return (
    <div className={className}>
      <Typography variant="heading" className={classes.title}>
        {t("404")}
      </Typography>
      <Typography variant="subheading" className={classes.subtitle}>
        {t("Uppps... page not found")}
      </Typography>
      <Typography variant="contentMedium" className={classes.informationText}>
        {t(
          "The page you are looking for was moved, removed, renamed or might never existed."
        )}
      </Typography>
      <div className={classes.contentWrapper}>{children}</div>
    </div>
  );
}

const createStyles = ({ typography, palette, breakpoints, spacing }: Theme) => {
  return {
    title: css({
      fontSize: typography.pxToRem(72),
      fontWeight: typography.fontWeight.thin,
      color: palette.default.text,
      margin: spacing([2, 0]),
      textAlign: "center",
      [breakpoints.up.sm]: {
        fontSize: typography.pxToRem(200),
      },
    }),
    subtitle: css({
      fontSize: typography.pxToRem(24),
      textAlign: "center",
      margin: spacing([2, 0]),
      color: grey[900],
      fontWeight: typography.fontWeight.semiBold,
    }),
    informationText: css({
      maxWidth: 320,
      margin: "0 auto",
      marginBottom: spacing(2),
      textAlign: "center",
    }),
    contentWrapper: css({
      display: "flex",
      justifyContent: "center",
    }),
  };
};
